import React, {useEffect, useState} from 'react';
import CostBreakdownListGroupItem from "./CostBreakdownListGroupItem";

/** The subset of a booking transaction invoice item that this component displays */
interface InvoiceItem {
  description?: string;
  /** Amount in cents */
  amount?: number | null;
}

interface InvoiceListGroupItemProps {
  invoiceItem?: InvoiceItem | null;
}

const InvoiceListGroupItem = (props: InvoiceListGroupItemProps) => {
  const {invoiceItem} = props;
  const [title, setTitle] = useState(invoiceItem?.description);
  // Holds the string[] result of split() for service charges, which React renders by concatenating the entries
  const [description, setDescription] = useState<string | string[]>('');

  useEffect(() => {
    const SERVICE_CHARGE = 'Service Charge';

    const stripServiceChargeDescription = (invoiceItemDescription: string): string[] => {
      return invoiceItemDescription.split(SERVICE_CHARGE + ' - ');
    }

    if (invoiceItem?.description && invoiceItem.description.startsWith(SERVICE_CHARGE)) {
      setTitle(SERVICE_CHARGE);
      setDescription(stripServiceChargeDescription(invoiceItem.description));
    }
  }, [invoiceItem]);

  return <CostBreakdownListGroupItem title={title}
                                     description={description}
                                     amount={invoiceItem?.amount}
  />
}

export default InvoiceListGroupItem;
